import type { IBaseEnvironmentClientAlpha } from '@blufin/web';
import { useContext } from 'react';
import { EnvironmentContextAlpha } from '../../context/EnvironmentContext/EnvironmentClientAlpha/EnvironmentContextAlpha';

/** Hook to access environment variables from components. */
export const useEnvironmentAlpha = <T extends object = {}>(): IBaseEnvironmentClientAlpha<T> => {
  const context = useContext(EnvironmentContextAlpha);
  if (!context) throw new Error('useEnvironmentAlpha() must be used within <EnvironmentProviderAlpha.Provider/>');
  return context as IBaseEnvironmentClientAlpha<T>;
};
